<template>
  <section
    id="experience"
    class="mb-16 scroll-mt-16 md:mb-24 lg:mb-36 lg:scroll-mt-24"
  >
    <div
      class="sticky top-0 z-20 -mx-6 mb-4 w-screen bg-slate-900/75 px-6 py-5 backdrop-blur md:-mx-12 md:px-12 lg:sr-only lg:relative lg:top-auto lg:mx-auto lg:w-full lg:px-0 lg:py-0 lg:opacity-0"
    >
      <h2
        class="text-sm font-bold uppercase tracking-widest text-slate-200 lg:sr-only"
      >
        Experience
      </h2>
    </div>
    <div>
      <ol class="group/list">
        <li class="mb-12">
          <div
            class="group relative grid pb-1 transition-all sm:grid-cols-8 sm:gap-8 md:gap-4 lg:hover:!opacity-100 lg:group-hover/list:opacity-50"
          >
            <div
              class="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-md transition motion-reduce:transition-none lg:-inset-x-6 lg:block lg:group-hover:bg-slate-800/50 lg:group-hover:shadow-[inset_0_1px_0_0_rgba(148,163,184,0.1)] lg:group-hover:drop-shadow-lg"
            ></div>
            <header
              class="z-10 mb-2 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2"
              aria-label="2024 to Present"
            >
              2024 - 2026
            </header>
            <div class="z-10 sm:col-span-6">
              <h3 class="font-medium leading-snug text-slate-200">
                <div>
                  <div
                    class="inline-flex items-baseline font-medium leading-tight text-slate-200 hover:text-teal-300 focus-visible:text-teal-300 group/link text-base"
                  >
                    <span
                      class="absolute -inset-x-4 -inset-y-2.5 hidden rounded md:-inset-x-6 md:-inset-y-4 lg:block"
                    ></span>
                    <div>
                      <span class="block mb-1"> Fullstack Web Developer </span>
                      <span class="block text-slate-500 text-sm">Brevonic</span>
                    </div>
                  </div>
                </div>
              </h3>
              <p class="mt-3 text-sm leading-normal">
                Developed and maintained fullstack web applications, building
                responsive and reusable frontend components while developing and
                integrating backend APIs. Collaborated with developers,
                designers, and product teams to deliver scalable, accessible,
                and user-friendly solutions.
              </p>
              <ul class="mt-2 flex flex-wrap" aria-label="Technologies used">
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Laravel
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Vue
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Tailwind
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Typescript
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Git
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    API
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="mb-12">
          <div
            class="group relative grid pb-1 transition-all sm:grid-cols-8 sm:gap-8 md:gap-4 lg:hover:!opacity-100 lg:group-hover/list:opacity-50"
          >
            <div
              class="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-md transition motion-reduce:transition-none lg:-inset-x-6 lg:block lg:group-hover:bg-slate-800/50 lg:group-hover:shadow-[inset_0_1px_0_0_rgba(148,163,184,0.1)] lg:group-hover:drop-shadow-lg"
            ></div>
            <header
              class="z-10 mb-2 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2"
              aria-label="2024 to Present"
            >
              2023 - 2024
            </header>
            <div class="z-10 sm:col-span-6">
              <h3 class="font-medium leading-snug text-slate-200">
                <div>
                  <div
                    class="inline-flex items-baseline font-medium leading-tight text-slate-200 hover:text-teal-300 focus-visible:text-teal-300 group/link text-base"
                  >
                    <span
                      class="absolute -inset-x-4 -inset-y-2.5 hidden rounded md:-inset-x-6 md:-inset-y-4 lg:block"
                    ></span>
                    <div>
                      <span class="block mb-1"> Fullstack Web Developer </span>
                      <span class="block text-slate-500 text-sm"
                        >Seven Lions Media</span
                      >
                    </div>
                  </div>
                </div>
              </h3>
              <p class="mt-3 text-sm leading-normal">
                Developed and maintained web applications and marketing
                platforms, integrating APIs and webhooks with third-party
                services. Implemented responsive interfaces, automated
                workflows, and A/B testing while ensuring reliable and
                maintainable application performance.
              </p>
              <ul class="mt-2 flex flex-wrap" aria-label="Technologies used">
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    JavaScript
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    TypeScript
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    API
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Webhooks
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Bootstrap
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    A/B Testing
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Clickbank
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="mb-12">
          <div
            class="group relative grid pb-1 transition-all sm:grid-cols-8 sm:gap-8 md:gap-4 lg:hover:!opacity-100 lg:group-hover/list:opacity-50"
          >
            <div
              class="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-md transition motion-reduce:transition-none lg:-inset-x-6 lg:block lg:group-hover:bg-slate-800/50 lg:group-hover:shadow-[inset_0_1px_0_0_rgba(148,163,184,0.1)] lg:group-hover:drop-shadow-lg"
            ></div>
            <header
              class="z-10 mb-2 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2"
              aria-label="2024 to Present"
            >
              2021 - 2023
            </header>
            <div class="z-10 sm:col-span-6">
              <h3 class="font-medium leading-snug text-slate-200">
                <div>
                  <div
                    class="inline-flex items-baseline font-medium leading-tight text-slate-200 hover:text-teal-300 focus-visible:text-teal-300 group/link text-base"
                  >
                    <span
                      class="absolute -inset-x-4 -inset-y-2.5 hidden rounded md:-inset-x-6 md:-inset-y-4 lg:block"
                    ></span>
                    <div>
                      <span class="block mb-1">
                        Fullstack Web Developer & Lead UI/UX Designer
                      </span>
                      <span class="block text-slate-500 text-sm"
                        >Brightprice Corporation</span
                      >
                    </div>
                  </div>
                </div>
              </h3>
              <p class="mt-3 text-sm leading-normal">
                Designed and developed web applications from concept to
                implementation, combining UI/UX design with fullstack
                development. Led interface design and frontend development while
                collaborating with stakeholders to create responsive, intuitive,
                and consistent user experiences.
              </p>
              <ul class="mt-2 flex flex-wrap" aria-label="Technologies used">
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Angular
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Vue
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Laravel
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Tailwind
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Bootstrap
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Sass
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Figma
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Adobe XD
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Git
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    API
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="mb-12">
          <div
            class="group relative grid pb-1 transition-all sm:grid-cols-8 sm:gap-8 md:gap-4 lg:hover:!opacity-100 lg:group-hover/list:opacity-50"
          >
            <div
              class="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-md transition motion-reduce:transition-none lg:-inset-x-6 lg:block lg:group-hover:bg-slate-800/50 lg:group-hover:shadow-[inset_0_1px_0_0_rgba(148,163,184,0.1)] lg:group-hover:drop-shadow-lg"
            ></div>
            <header
              class="z-10 mb-2 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2"
              aria-label="2024 to Present"
            >
              2021
            </header>
            <div class="z-10 sm:col-span-6">
              <h3 class="font-medium leading-snug text-slate-200">
                <div>
                  <div
                    class="inline-flex items-baseline font-medium leading-tight text-slate-200 hover:text-teal-300 focus-visible:text-teal-300 group/link text-base"
                  >
                    <span
                      class="absolute -inset-x-4 -inset-y-2.5 hidden rounded md:-inset-x-6 md:-inset-y-4 lg:block"
                    ></span>
                    <div>
                      <span class="block mb-1">
                        Fullstack Junior Web Developer
                      </span>
                      <span class="block text-slate-500 text-sm"
                        >AT Healthcare</span
                      >
                    </div>
                  </div>
                </div>
              </h3>
              <p class="mt-3 text-sm leading-normal">
                Developed and maintained web applications using Laravel and Vue,
                implementing responsive interfaces, backend APIs, and
                database-driven features. Collaborated with the development team
                to troubleshoot issues, improve application functionality, and
                deliver reliable solutions.
              </p>
              <ul class="mt-2 flex flex-wrap" aria-label="Technologies used">
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Laravel
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Vue
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Tailwind
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Typescript
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    AWS
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Git
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    API
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="mb-12">
          <div
            class="group relative grid pb-1 transition-all sm:grid-cols-8 sm:gap-8 md:gap-4 lg:hover:!opacity-100 lg:group-hover/list:opacity-50"
          >
            <div
              class="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-md transition motion-reduce:transition-none lg:-inset-x-6 lg:block lg:group-hover:bg-slate-800/50 lg:group-hover:shadow-[inset_0_1px_0_0_rgba(148,163,184,0.1)] lg:group-hover:drop-shadow-lg"
            ></div>
            <header
              class="z-10 mb-2 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2"
              aria-label="2024 to Present"
            >
              SINCE 2021
            </header>
            <div class="z-10 sm:col-span-6">
              <h3 class="font-medium leading-snug text-slate-200">
                <div>
                  <div
                    class="inline-flex items-baseline font-medium leading-tight text-slate-200 hover:text-teal-300 focus-visible:text-teal-300 group/link text-base"
                  >
                    <span
                      class="absolute -inset-x-4 -inset-y-2.5 hidden rounded md:-inset-x-6 md:-inset-y-4 lg:block"
                    ></span>
                    <div>
                      <span class="block mb-1">
                        Microcontroller Developer/Engineer
                      </span>
                      <span class="block text-slate-500 text-sm"
                        >Freelance</span
                      >
                    </div>
                  </div>
                </div>
              </h3>
              <p class="mt-3 text-sm leading-normal">
                Designed and developed microcontroller-based projects involving
                hardware integration, sensor programming, automation, and custom
                firmware. Built and tested prototypes while troubleshooting
                hardware and software issues to ensure reliable operation.
              </p>
              <ul class="mt-2 flex flex-wrap" aria-label="Technologies used">
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Arduino
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    ESP32
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    C/C++
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Electronics
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Sensors
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="mb-12">
          <div
            class="group relative grid pb-1 transition-all sm:grid-cols-8 sm:gap-8 md:gap-4 lg:hover:!opacity-100 lg:group-hover/list:opacity-50"
          >
            <div
              class="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-md transition motion-reduce:transition-none lg:-inset-x-6 lg:block lg:group-hover:bg-slate-800/50 lg:group-hover:shadow-[inset_0_1px_0_0_rgba(148,163,184,0.1)] lg:group-hover:drop-shadow-lg"
            ></div>
            <header
              class="z-10 mb-2 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2"
              aria-label="2024 to Present"
            >
              SINCE 2021
            </header>
            <div class="z-10 sm:col-span-6">
              <h3 class="font-medium leading-snug text-slate-200">
                <div>
                  <div
                    class="inline-flex items-baseline font-medium leading-tight text-slate-200 hover:text-teal-300 focus-visible:text-teal-300 group/link text-base"
                  >
                    <span
                      class="absolute -inset-x-4 -inset-y-2.5 hidden rounded md:-inset-x-6 md:-inset-y-4 lg:block"
                    ></span>
                    <div>
                      <span class="block mb-1">
                        Hardware & Software Computer Repair
                      </span>
                      <span class="block text-slate-500 text-sm"
                        >Freelance</span
                      >
                    </div>
                  </div>
                </div>
              </h3>
              <p class="mt-3 text-sm leading-normal">
                Diagnose, repair, and maintain desktop and laptop systems,
                covering hardware failures, software issues, upgrades, system
                optimization, and component replacement. Perform
                troubleshooting, cleaning, and preventative maintenance to
                restore system performance and reliability.
              </p>
              <ul class="mt-2 flex flex-wrap" aria-label="Technologies used">
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Hardware/Software
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Windows
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    PC Builds
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Troubleshooting
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Upgrades
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Maintenance
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Diagnostics
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="mb-12">
          <div
            class="group relative grid pb-1 transition-all sm:grid-cols-8 sm:gap-8 md:gap-4 lg:hover:!opacity-100 lg:group-hover/list:opacity-50"
          >
            <div
              class="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-md transition motion-reduce:transition-none lg:-inset-x-6 lg:block lg:group-hover:bg-slate-800/50 lg:group-hover:shadow-[inset_0_1px_0_0_rgba(148,163,184,0.1)] lg:group-hover:drop-shadow-lg"
            ></div>
            <header
              class="z-10 mb-2 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2"
              aria-label="2024 to Present"
            >
              SINCE 2021
            </header>
            <div class="z-10 sm:col-span-6">
              <h3 class="font-medium leading-snug text-slate-200">
                <div>
                  <div
                    class="inline-flex items-baseline font-medium leading-tight text-slate-200 hover:text-teal-300 focus-visible:text-teal-300 group/link text-base"
                  >
                    <span
                      class="absolute -inset-x-4 -inset-y-2.5 hidden rounded md:-inset-x-6 md:-inset-y-4 lg:block"
                    ></span>
                    <div>
                      <span class="block mb-1">
                        Multimedia Editing Services
                      </span>
                      <span class="block text-slate-500 text-sm"
                        >Freelance</span
                      >
                    </div>
                  </div>
                </div>
              </h3>
              <p class="mt-3 text-sm leading-normal">
                Create and edit multimedia content including videos, graphics,
                photos, and digital assets for personal and business projects.
                Handle video editing, image enhancement, motion graphics, and
                visual content production while maintaining quality and
                consistency across different platforms.
              </p>
              <ul class="mt-2 flex flex-wrap" aria-label="Technologies used">
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Video Editing
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Photo Editing
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Graphics Design
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Motion Graphics
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Visual Content
                  </div>
                </li>
                <li class="mr-1.5 mt-2">
                  <div
                    class="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300"
                  >
                    Digital Media
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ol>
      <div class="mt-12">
        <a
          class="inline-flex items-baseline font-semibold leading-tight text-slate-200 hover:text-teal-300 focus-visible:text-teal-300 group/link text-base"
          href="https://drive.google.com/file/d/103nd_fXVPPCNruX8TQHI1Xw4qQkFC4Dm/view?usp=sharing"
          target="_blank"
          rel="noreferrer noopener"
          aria-label="View Full Resume (opens in a new tab)"
        >
          <span
            >View Full
            <span class="inline-block">
              Resume
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                class="inline-block h-4 w-4 shrink-0 transition-transform group-hover/link:-translate-y-1 group-hover/link:translate-x-1 group-focus-visible/link:-translate-y-1 group-focus-visible/link:translate-x-1 motion-reduce:transition-none ml-1 translate-y-px"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </span>
          </span>
        </a>
      </div>
    </div>
  </section>
</template>
